import { useContext } from 'react';
import SalesOrderManagementContext from '../shared/context/SalesOrderManagementContext';


const useSalesOrderData = () => {
  const { data } = useContext(SalesOrderManagementContext);
  return data;
}

export default useSalesOrderData;